var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59077 19.9998H5.98357V11.7601L1.13672 8.125V18.5457C1.13672 19.3503 1.78862 19.9998 2.59077 19.9998Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6162 19.9998H21.009C21.8136 19.9998 22.4631 19.3479 22.4631 18.5457V8.125L17.6162 11.7601",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6162 5.45818V11.7591L22.4631 8.12395V6.18521C22.4631 4.38703 20.4104 3.36192 18.9733 4.44034",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98438 11.7579V5.45703L11.8006 9.8192L17.6168 5.45703V11.7579L11.8006 16.1201",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.13672 6.18521V8.12395L5.98357 11.7591V5.45818L4.62645 4.44034C3.18694 3.36192 1.13672 4.38703 1.13672 6.18521Z",
    fill: "#C5221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.341f7f52b00802f22128d5394f8c8af7.svg";
export { ForwardRef as ReactComponent };